module.exports = __webpack_public_path__ + "img/confirm mobile.0c555354.png";